import { DescargaCommonGlobal } from "./descarga.global";

export const emptyContenedoresResponse = {
    simulacionDescarga: [],
    sinFechaVencimiento: [],
};

export const getMaterialPadreEnDescarga = () => {
    const materialPadreIndex = DescargaCommonGlobal.enDescarga.materialesPadre.findIndex(
        (itm) => itm.uuid === DescargaCommonGlobal.enDescarga.padreId,
    );

    return DescargaCommonGlobal.enDescarga.materialesPadre[materialPadreIndex];
};

export const getIndexMaterialPadreEnDescarga = () => {
    const materialPadreIndex = DescargaCommonGlobal.enDescarga.materialesPadre.findIndex(
        (itm) => itm.uuid === DescargaCommonGlobal.enDescarga.padreId,
    );

    return materialPadreIndex;
};

export const getMaterialHijoEnDescarga = (materialPadre) => {
    const materialHijoIndex = materialPadre.listaMateriales.detalles.findIndex(
        (itm) => itm.uuid === DescargaCommonGlobal.enDescarga.hijoId,
    );

    return materialPadre.listaMateriales.detalles[materialHijoIndex];
};

export const getIndexMaterialHijoEnDescarga = (materialPadre) => {
    const materialHijoIndex = materialPadre.listaMateriales.detalles.findIndex(
        (itm) => itm.uuid === DescargaCommonGlobal.enDescarga.hijoId,
    );

    return materialHijoIndex;
};
